import React, { useEffect, useRef } from 'react';

function Services() {
    const cardsRef = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, observerOptions);

        cardsRef.current.forEach(card => {
            if (card) {
                card.style.opacity = '0';
                card.style.transform = 'translateY(30px)';
                card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                observer.observe(card);
            }
        });

        return () => observer.disconnect();
    }, []);

    return (
        <section id="services" className="section services-section">
            <div className="container">
                <div className="section-header">
                    <span className="section-tag">SERVICES</span>
                    <h2 className="section-title">사업 영역</h2>
                    <p className="section-description">
                        PCB 개발부터 양산까지, 전 과정을 책임집니다
                    </p>
                </div>
                
                <div className="services-grid">
                    <div className="service-card" ref={el => cardsRef.current[0] = el}>
                        <div className="service-number">01</div>
                        <div className="service-icon">
                            <i className="fas fa-pencil-ruler"></i>
                        </div>
                        <h3>PCB 설계 및 개발</h3>
                        <p>고객의 요구사항을 정확히 분석하여 최적화된 PCB 설계를 제공합니다. 다층 PCB, HDI, Flexible PCB 등 다양한 기술을 지원합니다.</p>
                        <ul className="service-features">
                            <li><i className="fas fa-check"></i> 회로 설계 및 시뮬레이션</li>
                            <li><i className="fas fa-check"></i> PCB 레이아웃 설계</li>
                            <li><i className="fas fa-check"></i> EMI/EMC 대책 설계</li>
                            <li><i className="fas fa-check"></i> 신호 무결성 분석</li>
                        </ul>
                    </div>
                    
                    <div className="service-card" ref={el => cardsRef.current[1] = el}>
                        <div className="service-number">02</div>
                        <div className="service-icon">
                            <i className="fas fa-cogs"></i>
                        </div>
                        <h3>PCB 양산</h3>
                        <p>소량 시제품부터 대량 양산까지 안정적인 생산 체계를 갖추고 있습니다. 엄격한 품질 관리로 불량률을 최소화합니다.</p>
                        <ul className="service-features">
                            <li><i className="fas fa-check"></i> 시제품 제작</li>
                            <li><i className="fas fa-check"></i> 대량 양산</li>
                            <li><i className="fas fa-check"></i> 부품 조달 및 실장</li>
                            <li><i className="fas fa-check"></i> 검사 및 테스트</li>
                        </ul>
                    </div>
                    
                    <div className="service-card" ref={el => cardsRef.current[2] = el}>
                        <div className="service-number">03</div>
                        <div className="service-icon">
                            <i className="fas fa-microscope"></i>
                        </div>
                        <h3>품질 관리 및 테스트</h3>
                        <p>첨단 장비를 이용한 철저한 품질 검증으로 고객에게 신뢰를 제공합니다. IPC 표준을 준수합니다.</p>
                        <ul className="service-features">
                            <li><i className="fas fa-check"></i> AOI 검사</li>
                            <li><i className="fas fa-check"></i> X-Ray 검사</li>
                            <li><i className="fas fa-check"></i> 기능 테스트</li>
                            <li><i className="fas fa-check"></i> 신뢰성 테스트</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Services;
